<ng-container *transloco="let t">
<div class="modal-header">

  <h2>{{ t('wizard.subjectProperty.title') }}</h2>

  <!-- hack to fool ngbModal autofocus -->

  <input type="text" style="display:none" />

  <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" [attr.aria-label]="t('common.close')"
       (click)="activeModal.dismiss()">
      <span class="svg-icon svg-icon-2x">
        <close-x-svg-icon></close-x-svg-icon>
      </span>
  </div>
</div>

<div class="modal-body py-10 px-lg-17">
  <form #subjectPropertySummaryForm="ngForm" class="form" novalidate id="subjectPropertySummaryForm" name="subjectPropertySummaryForm">
    <div class="me-n7 pe-7">
      <div class="row">
        <address [address]="address"></address>
      </div>
      <div class="row mb-5">
        <div class="col-md-6 fv-row">
          <label class="required form-label mb-2">{{ t('wizard.subjectProperty.type') }}</label>
          <select class="form-select form-select-solid" data-control="select2" name="propertyType"
                  [(ngModel)]="subjectProperty!.propertyType" #propertyType="ngModel" required
                  [ngClass]="{'is-invalid' : propertyType && propertyType.touched && propertyType.invalid}">
            <option value="">{{ t('common.selectOne') }}</option>
            @for (propertyType of propertyTypes; track propertyType.value) {
              <option [ngValue]="propertyType.value">
                {{propertyType.name}}
              </option>
            }
          </select>
          <div class="invalid-feedback">{{ t('common.pleaseSelectValue') }}</div>
        </div>
        <div class="col-md-6 fv-row">
          <label class="required form-label mb-2">{{ t('wizard.subjectProperty.willBe') }}</label>
          <select class="form-select form-select-solid" data-control="select2" name="type"
                  [(ngModel)]="subjectProperty!.propertyWillBe" #propertyWillBe="ngModel" required
                  [ngClass]="{'is-invalid' : propertyWillBe && propertyWillBe.touched && propertyWillBe.invalid}">
            <option value="">{{ t('common.selectOne') }}</option>
            @for (willBeType of willBeTypes; track willBeType.value) {
              <option [ngValue]="willBeType.value">
                {{willBeType.name}}
              </option>
            }
          </select>
          <div class="invalid-feedback">{{ t('common.pleaseSelectValue') }}</div>
        </div>
      </div>
      <div class="row mb-5">
        <div class="col-md-6 fv-row">
          <label class="required form-label mb-2">{{ t('wizard.subjectProperty.value') }}</label>
          <input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
                 [ngClass]="{'is-invalid' : presentValue && presentValue.touched && presentValue.invalid}"
                 #presentValue="ngModel" required [(ngModel)]="subjectProperty!.presentValue" placeholder="" name="presentValue" />
          <div class="invalid-feedback">{{ t('wizard.subjectProperty.valueRequired') }}</div>
        </div>
        <div class="col-md-6 fv-row">
          <label class="required form-label mb-2">{{ t('wizard.subjectProperty.yearBuilt') }}</label>
          <input class="form-control form-control-solid col-md-6" #yearBuilt="ngModel" name="yearBuilt" type="number"
                 [(ngModel)]="subjectProperty!.yearBuilt" [ngClass]="{'is-invalid' : yearBuilt && yearBuilt.touched && yearBuilt.invalid}" required />
          <div class="invalid-feedback">{{ t('wizard.subjectProperty.yearBuiltRequired') }}</div>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer flex-center">
  <button type="button" class="btn btn-white me-3" (click)="activeModal.dismiss()">{{ t('common.cancel') }}</button>
  <button type="button" class="btn btn-primary" (click)="onSaveClicked()">{{ t('common.ok') }}</button>
</div>
</ng-container>
